import React, { KeyboardEvent, useState } from 'react'
import { Input, Icon } from 'components'
import { LabeledInputProps } from './LabeledInput.types'
import styles from './LabeledInput.module.scss'
import cl from 'classnames'
import { RedMarkedText } from 'components/shared/RedMarkedText'
import { useInputExtraPaddingLeft } from 'utilities'

const LabeledInputComponent = (props: LabeledInputProps) => {
  const {
    className,
    style,
    keysToHandle,
    onKeyDown,
    onChange,
    size,
    label,
    type,
    placeholder,
    value: propsValue,
    onFocus,
    onBlur,
    onClick,
    error,
    min,
    icon,
    previousValue
  } = props

  const [value, setValue] = useState<string>('')

  const {
    versionBeforeValueRef,
    paddingLeft
  } = useInputExtraPaddingLeft()

  const handleOnKeyDown = (e: KeyboardEvent) => {
    if (!onKeyDown || !keysToHandle) return
    if (!keysToHandle.includes(e.key)) return

    onKeyDown(value)
    setValue('')
  }

  const handleOnChange = (value: string) => {
    onChange
      ? onChange(value)
      : setValue(value)
  }

  return (
    <div className={cl(styles.container, styles[size], className)} style={style}>
      {label && <label htmlFor=''>{label}</label>}
      <Input
        className={styles.input}
        style={{ paddingLeft }}
        type={type}
        placeholder={placeholder}
        value={propsValue || value}
        onChange={handleOnChange}
        onKeyDown={handleOnKeyDown}
        onFocus={onFocus}
        onBlur={onBlur}
        onClick={onClick}
        error={error}
        min={min}
      />

      {previousValue && (
        <RedMarkedText
          ref={versionBeforeValueRef}
          style={{ minWidth: 'unset', top: 'unset' }}
        >
          {previousValue}
        </RedMarkedText>
      )}

      {icon &&
        <Icon
          icon={icon}
          className={styles.icon}
          onClick={onClick}
        />
      }
    </div>
  )
}

const LabeledInput = LabeledInputComponent
export { LabeledInput }
